const entities: Record<string, string> = {
  amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", nbsp: " ",
  ndash: "–", mdash: "—", bull: "•", hellip: "…", deg: "°", times: "×",
};

/** Imported rich text becomes editable plain text; it is never rendered as HTML. */
export function estimateDescription(value: string | null | undefined): string {
  return (value ?? "")
    .replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, code: string) => {
      if (!code.startsWith("#")) return entities[code.toLowerCase()] ?? entity;
      const numeric = code[1].toLowerCase() === "x" ? parseInt(code.slice(2), 16) : Number(code.slice(1));
      return numeric > 0 && numeric <= 0x10ffff && !(numeric >= 0xd800 && numeric <= 0xdfff) ? String.fromCodePoint(numeric) : entity;
    })
    // ServiceTitan exports sometimes escape both sides of a tag, for example
    // `\\<li>…\\</li>`. Normalize only tag delimiters before stripping tags.
    .replace(/\\([<>])/g, "$1")
    .replace(/<(script|style|iframe)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, "")
    .replace(/\\?<br\s*\/?\s*>/gi, "\n")
    .replace(/<\/(?:p|div|li|ul|ol|h[1-6])\s*>/gi, "\n")
    .replace(/<li\b[^>]*>/gi, "• ")
    .replace(/<\/?(?:p|div|span|strong|b|em|i|u|s|a|ul|ol|h[1-6]|font|sub|sup)\b[^>]*>/gi, "")
    .replace(/\r\n?/g, "\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
